<div>
  <h3>{{ 'additional_data.title' | translate }}</h3>
  <p>{{ 'additional_data.subtitle' | translate }}</p>
</div>

<ul class="addtional-data-list">
  @if (cadence()) {
    <li>
      <input type="checkbox" name="cadence" id="cadence" />
      <label for="cadence">{{ 'additional_data.cadence' | translate }}</label>
    </li>
  }
  @if (power()) {
    <li>
      <input type="checkbox" name="power" id="power" />
      <label for="power">{{ 'additional_data.power' | translate }}</label>
    </li>
  }
  @if (heartRate()) {
    <li>
      <input type="checkbox" name="heartRate" id="heartRate" />
      <label for="heartRate">{{ 'additional_data.heart_rate' | translate }}</label>
    </li>
  }
</ul>
